<template>
    <div class="footerContiainer">
        <div class="topCont">
            <span class="title">运营支持</span>
            <span class="selCont">
                <span
                    v-for="(item, index) in list"
                    :key="index"
                    class="isPoint"
                    @click="goRouter(item)"
                    >{{ item.name }}</span
                >
            </span>
        </div>
        <div class="botCont">
            <div class="leftCont">
                <p>海南数字青耘科技有限公司</p>
                <p>
                    地址：海南省海口市美兰区新埠街道3号海商报业产业园区办公楼三楼
                </p>
                <p>电话：13876608998</p>
                <p class="botFont">
                    版权号：琼ICP备2022001675号
                </p>
            </div>
            <div class="codeContainer">
                <div class="codeCont">
                    <img
                        class="codeImg"
                        v-if="imgList.length && imgList[0].activeIcon"
                        :src="imgList[0].activeIcon"
                    />
                    <img
                        class="codeImg"
                        v-else
                        src="@/static/images/code.jpg"
                    />
                    <p>关注微信公众号</p>
                </div>
                <div class="codeCont">
                    <img
                        class="codeImg"
                        v-if="imgList.length && imgList[1].activeIcon"
                        :src="imgList[1].activeIcon"
                    />
                    <img
                        class="codeImg"
                        v-else
                        src="@/static/images/code.jpg"
                    />
                    <p>品牌准入授权平台</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getMenuInfo } from "@/utils/fc";
export default {
    props: {},
    data() {
        return {
               list: [
                {
                    name: "首页",
                    value: 0,
                    path: "/home",
                    open: true,
                    newPage: false,
                },
                {
                    name: "区域公用品牌",
                    value: 1,
                    path: "/brandPublic",
                    open: true,
                    newPage: false,
                },
                {
                    name: "一镇一品",
                    value: 2,
                    path: "/brandPublicAlone",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌风采",
                    value: 3,
                    path: "/brandStyle",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌纪实",
                    value: 4,
                    path: "/brandSummary",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌矩阵",
                    value: 5,
                    path: "/brandMap",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌报告",
                    value: 6,
                    path: "/brandReport",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌云图",
                    value: 7,
                    path: "daping.shuziqingyun.com/#/ppm",
                    open: true,
                    newPage: true,
                },
            ],
            imgList: [],
        };
    },
    mounted() {
        this.getData();
    },
    watch: {},
    updated() {},
    methods: {
        async getData() {
            let codes = {
                code1: "index",
                code2: "index:footerCode",
            };
            let res = await getMenuInfo(codes);
            if (
                res.menuPositionRelationList &&
                res.menuPositionRelationList.length
            ) {
                this.imgList = res.menuPositionRelationList;
            }
        },
       goRouter(item) {
            if (!item.open) {
                return this.$notify({
                    title: "提示",
                    message: "此模块暂时未开放",
                    type: "info",
                    duration: 3000,
                });
            }
            if (!item.newPage) {
               return this.$router.push(item.path);
            }
            if(item.newPage){
              return window.open('//'+item.path)
            }
        },
    },
};
</script>

<style scope lang="scss">
@import "./index.scss";
</style>


// WEBPACK FOOTER //
// src/components/footerCont/index.vue